// extracted by mini-css-extract-plugin
export default {"grid":"DomainsNotFound_grid__ru2zE","container":"DomainsNotFound_container__bN1n0"};